module.exports = __webpack_public_path__ + "img/mind_template_item_4_5.2edf24a0.png";